var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.433,
    height: 22.436,
    viewBox: "0 0 22.433 22.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_icon",
    "data-name": "search icon",
    transform: "translate(-403.787 -549.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-search",
    "data-name": "Icon awesome-search",
    d: "M22.128,19.4l-4.369-4.369a1.051,1.051,0,0,0-.745-.307H16.3A9.11,9.11,0,1,0,14.722,16.3v.714a1.051,1.051,0,0,0,.307.745L19.4,22.128a1.047,1.047,0,0,0,1.485,0l1.24-1.24a1.057,1.057,0,0,0,0-1.49ZM9.114,14.722a5.609,5.609,0,1,1,5.609-5.609A5.605,5.605,0,0,1,9.114,14.722Z",
    transform: "translate(403.787 549.686)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    d: "M6.144,4.849H4.017V2.723a.473.473,0,0,0-.473-.473H3.072a.473.473,0,0,0-.473.473V4.849H.473A.473.473,0,0,0,0,5.322v.473a.473.473,0,0,0,.473.473H2.6V8.394a.473.473,0,0,0,.473.473h.473a.473.473,0,0,0,.473-.473V6.267H6.144a.473.473,0,0,0,.473-.473V5.322A.473.473,0,0,0,6.144,4.849Z",
    transform: "translate(5.982 3.25)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomPlus);
export default __webpack_public_path__ + "static/media/zoom_plus.3b8af54151716c42a9fa92d252f9b44b.svg";
export { ForwardRef as ReactComponent };